"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWinstonLogger = void 0;
var useWinstonLogger_1 = require("./useWinstonLogger");
Object.defineProperty(exports, "useWinstonLogger", { enumerable: true, get: function () { return __importDefault(useWinstonLogger_1).default; } });
//# sourceMappingURL=index.js.map